<template>
  <v-container grid-list-xl>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12>
        <h2 class="display-2 my-4 text-xs-center">Our Agents</h2>
      </v-flex>
      <v-flex xs12 sm12 md6 lg4 xl3>
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            :to="{ name: 'philip-roy' }"
          >
            <v-img
              :src="require('../assets/PR_Properties_Las_Vegas_Real_Estate_Phil_Roy_400w.jpg')"
              alt="Philip A Roy"
            >
            </v-img>
            <v-card-title primary-title class="pb-0">
              <div>
                <h3 class="title mb-0">Philip A. Roy</h3>
                <p class="subheading grey--text">
                  Real Estate Broker
                </p>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex class="body-2">
                  Mobile: <a href="tel:+1-702-858-8778">702-858-8778</a>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex class="body-2 text-xs-right">
                  Email:&nbsp;
                  <router-link to="/contact">contact me</router-link>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat color="info" :to="{ name: 'philip-roy' }">
                Read More
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Agents',
  metaInfo: {
    title: 'Agents',
  },
};
</script>
